import { api, handleApiError } from '@/lib/api';
import type {
  PromoOffer,
  PromoOfferListResponse,
  CreatePromoOfferDTO,
  UpdatePromoOfferDTO,
} from '../types';

export const promoOfferApi = {
  list: async (query?: string): Promise<PromoOfferListResponse> => {
    try {
      const url = query 
        ? `/admin/promo-offers?${new URLSearchParams({ search: query }).toString()}`
        : '/admin/promo-offers';
      return await api.get<PromoOfferListResponse>(url);
    } catch (error) {
      handleApiError(error, { operation: 'list_promo_offers', query });
      throw error;
    }
  },

  create: async (data: CreatePromoOfferDTO): Promise<PromoOffer> => {
    try {
      // Convert Date to ISO string if needed
      const payload = {
        ...data,
        expires_at: data.expires_at instanceof Date 
          ? data.expires_at.toISOString() 
          : data.expires_at
      };
      return await api.post<PromoOffer>('/admin/promo-offers', payload);
    } catch (error) {
      handleApiError(error, { operation: 'create_promo_offer', data });
      throw error;
    }
  },

  update: async (
    promoOfferId: number,
    data: UpdatePromoOfferDTO
  ): Promise<PromoOffer> => {
    try {
      // Convert Date to ISO string if needed
      const payload = data.expires_at 
        ? {
            ...data,
            expires_at: data.expires_at instanceof Date 
              ? data.expires_at.toISOString() 
              : data.expires_at
          }
        : data;
      return await api.put<PromoOffer>(`/admin/promo-offers/${promoOfferId}`, payload);
    } catch (error) {
      handleApiError(error, { operation: 'update_promo_offer', promoOfferId, data });
      throw error;
    }
  },

  delete: async (promoOfferId: number): Promise<void> => {
    try {
      return await api.delete<void>(`/admin/promo-offers/${promoOfferId}`);
    } catch (error) {
      handleApiError(error, { operation: 'delete_promo_offer', promoOfferId });
      throw error;
    }
  },
};